import React, {Fragment} from 'react'
import { KTIcon } from 'src/marketConnect/helpers'
import { useAppSelector } from 'src/redux/storeHooks'
import { formatDateLocal } from 'src/utils/TimeZoneDateFormat'
import { useCustomerAccess } from 'src/hooks/useCustomerAccess'
import { shouldShowAction, getActionButtonProps, getFormFieldDisabled } from 'src/utils/customerAccessUtils'
import { usePermission } from 'src/hooks/usePermission'

type TemplateListItemcopyProps = {
  name: any
  mapped_attribute_name?: any
  mapped_cat_name?: any
  created_at?: any
  updated_at?: any
  onUpdate: any
  onDelete: any
}

const TemplateListItemcopy = ({
  name,
  mapped_attribute_name,
  mapped_cat_name,
  created_at,
  updated_at,
  onUpdate,
  onDelete,
}: TemplateListItemcopyProps) => {
    const {isRead, isWrite, isDelete} = usePermission();
    const hasMappingColumns = mapped_attribute_name !== undefined || mapped_cat_name !== undefined

  const { fetchedUserAccountData } = useAppSelector(state=>state.userAccountData)
  const customerAccess = useCustomerAccess()

  return (
    <>
      
      <tr className='w-100' >
      <td className={`${hasMappingColumns ? 'min-w-175px' : 'w-50 max-w-100px'} ps-3`}>
        <span className='text-dark fw-bold text-hover-primary fs-6'>{name}</span>
      </td>
      {mapped_attribute_name !== undefined && (
        <td className='min-w-175px ps-3'>
          <span className='text-dark fw-bold text-hover-primary fs-6'>{mapped_attribute_name || '-'}</span>
        </td>
      )}
      {mapped_cat_name !== undefined && (
        <td className='min-w-140px ps-3'>
          <span className='text-dark fw-bold text-hover-primary fs-6'>{mapped_cat_name || '-'}</span>
        </td>
      )}
      {created_at && <td className='min-w-175px text-nowrap ps-3'>
        <span className='text-dark fw-bold text-hover-primary fs-6'>{formatDateLocal(created_at)}</span>
      </td>}
      {updated_at && <td className='min-w-175px text-nowrap ps-3'>
        <span className='text-dark fw-bold text-hover-primary fs-6'>{formatDateLocal(updated_at)}</span>
      </td>}
      <td className='w-25 text-center p-1'>
        <div className='d-flex justify-content-center'>
          {isRead && shouldShowAction(customerAccess, 'edit') && (() => {
            const updateButtonProps = getActionButtonProps(customerAccess, 'edit')
            return (
              <button          
                className='btn btn-icon btn-bg-light btn-color-primary btn-sm me-3 mt-1'
                onClick={onUpdate}
                {...updateButtonProps}
                disabled={updateButtonProps.disabled || getFormFieldDisabled(customerAccess)}
                style={updateButtonProps.style}
                title={updateButtonProps.title}
              >
                <KTIcon iconName='pencil'  className='fs-4' />
              </button>
            )
          })()}
          {isDelete && shouldShowAction(customerAccess, 'delete') && (() => {
            const deleteButtonProps = getActionButtonProps(customerAccess, 'delete')
            return (
              <button
                {...deleteButtonProps}
                disabled={deleteButtonProps.disabled || getFormFieldDisabled(customerAccess)}
                className='btn btn-icon btn-bg-light btn-color-danger btn-sm mt-1'
                onClick={onDelete}
                style={deleteButtonProps.style}
                title={deleteButtonProps.title}
              >
                <KTIcon iconName='trash' className='fs-4' />
              </button>
            )
          })()}
        </div>
      </td>
    </tr>
           

      {/* <div className='d-flex   justify-content-between align-items-center  m-2 mt-2'>
        <div className='d-flex justify-content-start col-9'>
          <p className='mb-0 ms-4'>{name}</p>
        </div>
        <div className='d-flex align-items-center col-3 justify-content-end me-3'>
          {' '}
         
          <button
            className='btn btn-primary d-flex align-items-center justify-content-center '
            onClick={onUpdate}
          >
            <i className='bi bi-pencil-square'></i>
          </button>
      
          <button
            className='btn  btn-danger d-flex align-items-center justify-content-center ms-3
          '
            onClick={onDelete} 
          >
            <i className='bi bi-trash'></i>
          </button>
        </div>
        <div className='border-bottom border-2 my-2 mt-5' /> 
      </div> */}
    </>
  )
}

export default TemplateListItemcopy
